module.exports = __webpack_public_path__ + "static/media/naszemiasto.77fa1c27.svg";